import React from 'react'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import {WelcomeMessageConfig} from 'Event/template/Cards/Dashboard/WelcomeMessage/WelcomeMessageConfig'
import {useAttendeeVariables} from 'Event'
import {useCardsTemplate} from 'Event/template/Cards'
import {useToggle} from 'lib/toggle'
import EditModeOnly from 'Event/Dashboard/editor/views/EditModeOnly'
import {useEditMode} from 'Event/EditModeProvider'
import HTMLContent from 'lib/ui/form/HTMLEditor/HTMLContent'

export default function WelcomeMessage() {
  const template = useCardsTemplate()
  const isEdit = useEditMode()

  if (!isEdit && !template.header.isEnabled) {
    return null
  }

  return (
    <>
      <EditModeOnly>
        <EditButton />
      </EditModeOnly>
      <>
        <WelcomeMessageText />
      </>
    </>
  )
}

function EditButton() {
  const {flag: configVisible, toggle: toggleConfig} = useToggle()

  return (
    <>
      <WelcomeMessageConfig showing={configVisible} onClose={toggleConfig} />
      <StyledEditButton
        onClick={toggleConfig}
        fullWidth
        size="large"
        variant="outlined"
        color="primary"
        aria-label="edit welcome message"
      >
        Edit Welcome Message
      </StyledEditButton>
    </>
  )
}

function WelcomeMessageText() {
  const {
    welcomeMessage: {text: welcomeText},
  } = useCardsTemplate()

  const v = useAttendeeVariables()

  if (!welcomeText) {
    return null
  }

  return <Text aria-label="welcome message">{v(welcomeText)}</Text>
}

const Text = styled(HTMLContent)`
  line-height: 1.5;
  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
  text-align: center;
  &:empty {
    height: ${(props) => props.theme.spacing[5]};
    width: 100%;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    line-height: 2.5;
  }
`

const StyledEditButton = styled(Button)`
  margin-top: 20px;
`
